export default "__VITE_ASSET__69ad65b6__"